"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubDashboardViewSwitcher = void 0;
var react_1 = __importDefault(require("react"));
var Pivot_1 = require("office-ui-fabric-react/lib/Pivot");
var VIEW_SWITCHER_ITEMS = [
    { key: "list", label: "List", iconName: "BulletedList" },
    { key: "progress", label: "Progress", iconName: "GridViewMedium" },
    { key: "dashboard", label: "Dashboard", iconName: "ViewDashboard" },
];
/**
 * Toggle controls for switching between dashboard views.
 *
 * Implemented with Fluent UI's `Pivot` (tabs format) so the switcher
 * stays consistent with the rest of the Fluent-based AI Hub toolbar.
 *
 * @param {WsAiHubDashboardViewSwitcherProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubDashboardViewSwitcher = function (props) {
    var handleLinkClick = function (item) {
        if (!item || !item.props.itemKey) {
            return;
        }
        props.onViewChange(item.props.itemKey);
    };
    return (react_1.default.createElement(Pivot_1.Pivot, { className: "ws-ai-hub-dashboard-view-switcher", selectedKey: props.selectedView, onLinkClick: handleLinkClick, linkFormat: Pivot_1.PivotLinkFormat.tabs, linkSize: Pivot_1.PivotLinkSize.normal, headersOnly: true }, VIEW_SWITCHER_ITEMS.map(function (item) { return (react_1.default.createElement(Pivot_1.PivotItem, { key: item.key, itemKey: item.key, headerText: item.label, itemIcon: item.iconName })); })));
};
exports.WsAiHubDashboardViewSwitcher = WsAiHubDashboardViewSwitcher;
